<div class="alert" [ngClass]="errorMsg.class" *ngIf="show">
    <strong>{{errorMsg.msg}}</strong>
    <a class="alert-link"> {{errorMsg.message}}</a>.
</div>
